<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <span class="note"><i style="color: red">*</i> 确定要撤回复苏申请吗？</span><br/>
            <div v-if="this.selects && this.selects.length>0">
                <el-select style="float:left;margin-left:10px;margin-top:10px" v-model="textarea" placeholder="请选择">
                    <el-option
                    v-for="(item, index) in selects"
                    :key="index"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div v-else>
                <el-input style="margin-top: 20px" type="textarea" :rows="2" placeholder="请输入撤回原因" v-model="textarea" @blur="check"></el-input>
            </div>
        </div>
        <CloseButton type="confirm" @confirm="surgeryReturn" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `cancelRecoveryApply`,
    props: {

    },
    data() {
        return {
            title: `撤回复苏申请`,
            token: this.$route.query.token,
            id: this.$route.query.surgery_id,
            recordType: this.$route.query.recordType,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            data: {},
            msg: `closeWindow`,
            textarea: ``,
            cancelRecoveryApplySelects: this.$root.cancelRecoveryApplySelects
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
        selects() {
            let str = this.cancelRecoveryApplySelects
            if (!_.isString(str)) {
                return []
            }

            let parsed
            try {
                parsed = JSON.parse(str)
            } catch (e) {
                return []
            }
            return _.isArray(parsed) ? parsed : []
        }
    },
    methods: {
        surgeryReturn() {
            let that = this
            if (!that.check()) return false
            return new Promise((resolve) => {
                let req = that.myaxios.get(`/api/Operation/RecoveryApplyMessage/ChangeApplyMessage?bizId=${this.$route.query.surgery_id}&status=2&content=${this.textarea}&is_handle=false`)
                req.then(data => {
                    that.$message.success(`已撤回成功`)
                    that.data = { surgeryId: this.$route.query.surgery_id }
                    that.msg = `ok`
                    that.sendMessage()
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.textarea === ``) {
                this.$message.warning(`撤回原因不能为空`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/CancelRecoveryApply.vue